import { createRouter, createWebHashHistory } from "vue-router";
import Prochip from './pages/Prochip.vue';
import Callback from './pages/Callback.vue';
import SignOut from "./pages/SignOut.vue";
import { checkTokenExpiry, signIn } from './security/authRedirect';
import store from './store';

const routes = [
  {
    path: '/',
    name: 'prochiplicensing',
    component: Prochip,
    meta: {
      requireAuth: true,
      headerName: 'Request a 30-day license',
      tabName: 'Prochip 30-days Licensing',
      breadcrumb: [
        {
          name: 'Products',
          externalLink: 'https://www.microchip.com/en-us/products',
        },
        {
          name: 'FPGAs and PLDs',
          externalLink: 'https://www.microchip.com/en-us/products/fpgas-and-plds',
        },
        {
          name: 'SPLD/CPLDs',
          externalLink: 'https://www.microchip.com/en-us/products/fpgas-and-plds/spld-cplds',
        },
        {
          name: 'PLD Design Resources',
          externalLink: 'https://www.microchip.com/en-us/products/fpgas-and-plds/spld-cplds/pld-design-resources',
        },
        {
          name: 'Prochip Licensing',
        },
      ],
      props: true,
    },
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback,
    meta: {
      requireAuth: false
    }
  },
  {
        path: '/signout',
        name: 'signout',
        component: SignOut,
        meta: {
            requireAuth: true
        }
    },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {

    // Getting the base path from the URL, e.g. "/prochiplicensing" or "/prochip2yearslicensing"
    const basePath = window.location.pathname.toLowerCase();

    // Dynamically update the meta fields based on the base path
    if (basePath.includes('prochiplicensing')) {
      to.meta.headerName = 'Request a 30-day license';
      to.meta.tabName = 'Prochip 30-days Licensing';
    } else if (basePath.includes('prochip2yearslicensing')) {
      to.meta.headerName = 'Request a 2-year license';
      to.meta.tabName = 'Prochip 2-years Licensing';
    } else {
      // fallback or default
      to.meta.headerName = 'Request a 30-day license';
      to.meta.tabName = 'Prochip 30-days Licensing';
    }

    const $cookies = router.app?.config?.globalProperties?.$cookies;
    
    // Handle cookies and localStorage for the authenticated user
    const userCookie = $cookies.get("wwwmicrochipuser");
    const userNameCookie = $cookies.get("wwwmicrochipusername");
    let loggedUserID = $cookies.get("asdfdiuglkjhrsu");

    localStorage.setItem("sdfsdgsgsgs", loggedUserID);
    localStorage.setItem("qwecvgvdf-ewrefk", userCookie);

    // Clear cookies if the user is not fully authenticated (missing cookies)
    if (userCookie && userNameCookie && !loggedUserID) {
        $cookies.remove("wwwmicrochipuser");
        $cookies.remove("wwwmicrochipusername");
        loggedUserID = "";
    }

    // Store the current route and query for reference
    localStorage["Route"] = to.path;
    localStorage["RouteQuery"] = to.query.category;

    // Handle the referrer for 'my-settings' and 'my-profile' routes
    if (to.path.includes("my-settings") && to.query.category?.includes("myprofile")) {
        if (
            localStorage["RouteQuery"] !== '' &&
            !document.referrer.includes(window.location.host) &&
            !document.referrer.includes("b2clogin") &&
            !document.referrer.includes(process.env.VUE_APP_AUTH_DOMAIN)
        ) {
            if (
                document.referrer !== '' &&
                (localStorage["referrer"] === '' || localStorage["referrer"] === undefined) &&
                !document.referrer.includes(process.env.VUE_APP_URL)
            ) {
                localStorage["referrer"] = document.referrer;
            }
        }
    }
    if(to.meta.requireAuth) {
        const response = await checkTokenExpiry();
        if(response) {
            store.commit('prochip/setAccessToken', response);
            return next();
        } else {
            await signIn();
            return next();
        }
    } else {
        return next();
    }
});

export default router;